import React from 'react';
import UserLayout from "../components/layouts/UserLayout";
import styled from "styled-components";
import UserHead from "../config/UserHead";

const NotFoundStyle = styled.div`
  margin: 0 30px;
`;

const NotFound: React.FC = (() => {
  return (
    <UserLayout>
      <UserHead title='ページが見つかりません' />
      <NotFoundStyle>
        <h1>ページが見つかりませんでした</h1>
      </NotFoundStyle>
    </UserLayout>
  );
});
export default NotFound;
